import { Yup, type YupTypes, inputFileSchema } from "@pharmupp/p3-front-commons"
import { fields } from "../../extraLabNewsFlash.const"

export const schema = Yup.object({
  publishLater: Yup.boolean().required(),
  publicationDate: Yup.date().when(
    fields.publishLater,
    ([publishLater]: boolean[], schemaRef) =>
      publishLater === true ? schemaRef.required() : schemaRef,
  ),
  title: Yup.string().max(100).required(),
  description: Yup.string().required(),
  image: inputFileSchema.default(undefined).required(),
})

export type GeneralInfosValues = YupTypes.InferType<typeof schema>
